import * as Analytics from '@/helpers/analytics.js'
import axios from 'axios'
import router from '@/router'
import store from '@/store/index.js'
import * as Network from '@/helpers/network.js'
export let defaults = {
    headers: {
        'Content-Type': 'application/json',
        common: {}
    }
}
const timeout = 12000
export function get(url) {
    return request('get', url)
}
export function post(url, data) {
    return request('post', url, data)
}
export function patch(url, data) {
    return request('patch', url, data)
}
export function put(url, data) {
    return request('put', url, data)
}
export function remove(url, data) {
    return request('delete', url, data)
}

function refreshJWT() {
    return axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}${'v1/refresh-jwt'}`,
        headers: defaults.headers,
        timeout: timeout
    })
}

function repeatWithRefresh(method, url, requestData, resolve, reject) {
    refreshJWT()
        .then(({ data }) => {
            defaults.headers.common['Authorization'] = `Bearer ${data}`
            axios({
                method: method,
                url: `${process.env.VUE_APP_API_URL}${url}`,
                data: requestData ? requestData : {},
                headers: defaults.headers,
                timeout: timeout
            })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
        .catch(error => {
            store.dispatch('resetStore')
            router.push('/')
            reject(error)
        })
}
function request(method, url, data) {
    const networkUrl = Network.provideURL(url)
    return new Promise((resolve, reject) => {
        const params = defaults.headers.common['Authorization']
            ? {}
            : { sub_region: 'pl200' }
        axios({
            method: method,
            url: `${process.env.VUE_APP_API_URL}${networkUrl}`,
            params,
            data: data ? data : {},
            headers: defaults.headers,
            timeout: timeout
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                if (error.response) {
                    const status = error.response.status
                    const { type } = error.response.data.error
                    switch (true) {
                        case type === 'JWTExpired' || type === 'JWTInavlid':
                            repeatWithRefresh(
                                method,
                                networkUrl,
                                data,
                                resolve,
                                reject,
                                error
                            )
                            break
                        case status === 500:
                            handle500Error(error)
                            reject(error)
                            break
                        case status == 502:
                            handle502Error(error)
                            reject(error)
                            break
                        default:
                            reject(error)
                    }
                } else {
                    reject(error)
                }
            })
    })
}
async function handle502Error(error) {
    Analytics.send500Error(error.response)
}
function handle500Error(error) {
    if (!error || !error.config) {
        return
    }
    const { url } = error.config
    if (!url || url.includes('crisp')) {
        return
    }
    Analytics.send500Error(error.response)
}
